import {
    KNOWLEDGE_ITEM_RESPONSE,
    MODERATION_FEED_ITEM_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    MODERATION_FEED_ITEM_SAVE_RESPONSE,
    KNOWLEDGE_LIST_RESPONSE,
    MODERATION_FEED_LIST_RESPONSE,
    CLUSTER_ITEM_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { normalise } from "../../models/entities/feed"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case KNOWLEDGE_ITEM_SAVE_RESPONSE:
        case MODERATION_FEED_ITEM_SAVE_RESPONSE:
        case KNOWLEDGE_ITEM_RESPONSE:
        case MODERATION_FEED_ITEM_RESPONSE:
            const { id } = data
            const has_source =
                data.has_source !== undefined
                    ? data.has_source
                    : state[id] && state[id].has_source
            return {
                ...state,
                [id]: {
                    ...normalise(data),
                    has_source,
                    lastUpdatedAt: receivedAt
                }
            }
        case KNOWLEDGE_LIST_RESPONSE:
        case MODERATION_FEED_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case CLUSTER_ITEM_RESPONSE:
            return extractEntitiesFromData(data.articles, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
